import {create} from 'zustand';
import {devtools} from 'zustand/middleware';
import {
    createAdminGridSearchSlice,
    ICreateAdminGridSearchSlice,
    ICreateAdminUserSearchSlice,
    createAdminUserSearchSlice,
} from './slices';
/**
 * Make sure to enforce type for each slice
 */

export const useAppAdminStore = create<
    ICreateAdminGridSearchSlice &
    ICreateAdminUserSearchSlice
    >()(
    devtools((...a) => ({
        ...createAdminGridSearchSlice(...a),
        ...createAdminUserSearchSlice(...a),
    }))
);